<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryOnLoad="queryOnLoad" :mountedHandler="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <el-table :data="dataList" border style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40" :selectable="canSelectRow" align="center"></el-table-column>
            <el-table-column align="left" prop="name" label="字段编码" width="200"></el-table-column>
            <el-table-column align="left" prop="title" label="中文标题" width="200"></el-table-column>
            <el-table-column align="left" prop="type" label="类型" width="200">
                <template slot-scope="rows">
                    <span>{{typeMap[rows.row.type]}}</span>
                </template>
            </el-table-column>
            <el-table-column align="left" prop="desc" label="说明"></el-table-column>
            <el-table-column align="center" width="100" label="必填项">
                <template slot-scope="rows">
                    <el-checkbox :disabled="!canSelectRow(rows.row)" v-model="rows.row.required"></el-checkbox>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import { checkUserActionPerm } from '../index'
    import { getDefaultPageSizes } from '../../app.conf'
    import { getSimpleJavaTypes, getSimpleJavaTypesMap } from './selectDlg'

    import merchtComnApi from '../../api/merchtComn'

    import SwbMerchtTplRoleSave from './DevcCustFieldSave';
    Vue.regist(SwbMerchtTplRoleSave);

    let mockConfigData = {
        "queryFields": [
            {
                "code": "name",
                "label": "字段编码",
                "type": "Text",
                "valueType": "String",
                "basic": true,
                "hidden": false,
                "rptUsed": false
            }, {
                "code": "title", "label": "中文标题", "type": "Text", "valueType": "String", "basic": true, "hidden": false, "rptUsed": false
            }, {
                "code": "desc", "label": "说明", "type": "Text", "valueType": "String", "basic": true, "hidden": false, "rptUsed": false
            }
        ],
        "sortFields": []
    };

    //    , {
    //        "code": "type",
    //            "label": "类型",
    //            "type": "Select",
    //            "valueType": "String",
    //            "basic": true,
    //            "hidden": false,
    //            "rptUsed": false,
    //            "dataList": []
    //    }
    export default {
        name: 'swb-devc-cust-field-list-select',
        props: ["custFieldIds"],
        data: function () {
            return {
                queryConfig: mockConfigData,
                queryOnLoad: true,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                typeMap: {},
                dataList: [],
                multipleSelection: [],
            }
        },
        created: function () {
            this.typeMap = getSimpleJavaTypesMap();
        },
        methods: {
            onQueryConfigReady: function (event) {
                let typeList = [];
                let types = getSimpleJavaTypes(true);
                let typeMap = this.typeMap;
                types.forEach(function (type) {
                    typeList.push({
                        value: type,
                        label: typeMap[type]
                    });
                });
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                query_model_ctrl.updateFields({
                    type: {
                        dataList: typeList
                    }
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.getDataList();
            },
            getDataList(){
                let self = this;
                let postData = {};
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcCustFieldList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        let dataList = result.data || [];
                        for(let i = 0; i < dataList.length; i++) {
                            dataList[i].required = false;
                        }
                        self.dataList = Utils.merge([], dataList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            canSelectRow(row, index){
                return !this.custFieldIds.contains(row.id);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            getDlgResult: function () {
                return this.multipleSelection || [];
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcCust/DevcCustFieldListSelect.vue